export const ACCEPTABLE_ATTRIBUTE_TYPES = new Set(['string', 'number', 'boolean']);
export default function MetricAttributes(attributes) {
    let currentAttributes = attributes || {};
    function toAttributes() {
        return Object.entries(currentAttributes).reduce((result, [key, value]) => {
            if (!ACCEPTABLE_ATTRIBUTE_TYPES.has(typeof value)) {
                return result;
            }
            if (key === 'msDuration'
                && (Number(value) < 0 || Number(value) > 9999999999999.99 || Number.isNaN(value))) {
                return result;
            }
            return Object.assign(Object.assign({}, result), { [key]: value });
        }, {});
    }
    return {
        clear() {
            currentAttributes = {};
        },
        mergeAttributes(newAttributes) {
            if (newAttributes == null) {
                return;
            }
            if (newAttributes.constructor !== Object) {
                return;
            }
            currentAttributes = Object.assign(Object.assign({}, currentAttributes), newAttributes);
        },
        toAttributes,
        toStringAttributes() {
            return Object.entries(toAttributes()).reduce((result, [key, value]) => (Object.assign(Object.assign({}, result), { [key]: value.toString().substring(0, 200) })), {});
        },
    };
}
//# sourceMappingURL=MetricAttributes.js.map